const _excluded = ["children", "title", "backTitle", "mobileTitle", "isDesktop", "onClose"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { Button, CloseButton, ConfirmationModal, CustomModal, TextButton, Typography } from 'seagull';
import styles from "./ResponsiveModal.module.scss";
import { WideArrowBackward } from 'seagull/icons';
function isConfirmationModalProps(props) {
  return 'onPrimaryButtonClick' in props;
}
export function ResponsiveModal(props) {
  var _props$skin, _props$skin2;
  const {
      children,
      title,
      backTitle,
      mobileTitle = title,
      isDesktop,
      onClose
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  if (isDesktop) {
    if (isConfirmationModalProps(props)) {
      const {
        skin,
        primaryButtonDisabled,
        primaryButtonLabel,
        primaryButtonIntent,
        onPrimaryButtonClick,
        secondaryButtonLabel,
        onSecondaryButtonClick
      } = props;
      return /*#__PURE__*/React.createElement(ConfirmationModal, _extends({
        textAlignCenter: false,
        content: children,
        title: title !== null && title !== void 0 ? title : '',
        skin: skin,
        onCloseButtonClick: onClose,
        primaryButtonIntent: primaryButtonIntent,
        primaryButtonDisabled: primaryButtonDisabled,
        primaryButtonLabel: primaryButtonLabel,
        onPrimaryButtonClick: onPrimaryButtonClick,
        secondaryButtonLabel: secondaryButtonLabel,
        onSecondaryButtonClick: onSecondaryButtonClick
      }, rest));
    } else {
      return /*#__PURE__*/React.createElement(CustomModal, _extends({
        hideCloseBtn: true,
        maxWidth: 600
      }, rest), /*#__PURE__*/React.createElement("div", {
        className: styles.customModal
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.customModalHeader
      }, /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement(Typography, {
        variant: "h6",
        weight: "bold"
      }, title), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(CloseButton, {
        skin: "transparent",
        onClick: onClose
      }))), /*#__PURE__*/React.createElement("div", {
        className: styles.customModalBody
      }, children)));
    }
  }
  return /*#__PURE__*/React.createElement("div", _extends({
    className: styles.mobileModal
  }, rest), /*#__PURE__*/React.createElement("div", {
    className: styles.mobileModalHeader
  }, /*#__PURE__*/React.createElement(TextButton, {
    skin: "secondary",
    prefixIcon: /*#__PURE__*/React.createElement(WideArrowBackward, null),
    underline: "hover",
    onClick: onClose
  }, backTitle)), /*#__PURE__*/React.createElement("div", {
    className: styles.mobileModalBody
  }, mobileTitle && /*#__PURE__*/React.createElement(Typography, {
    weight: "bold",
    variant: "h6",
    className: styles.mobileModalTitle
  }, mobileTitle), children), /*#__PURE__*/React.createElement("div", {
    className: styles.mobileModalFooter
  }, isConfirmationModalProps(props) ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    fluid: true,
    size: "medium",
    skin: "".concat((_props$skin = props.skin) !== null && _props$skin !== void 0 ? _props$skin : 'primary'),
    onClick: props.onPrimaryButtonClick,
    "data-testid": "confirmation-modal-primary-btn",
    disabled: props.primaryButtonDisabled
  }, props.primaryButtonLabel), props.secondaryButtonLabel && /*#__PURE__*/React.createElement(Button, {
    fluid: true,
    size: "medium",
    skin: "".concat((_props$skin2 = props.skin) !== null && _props$skin2 !== void 0 ? _props$skin2 : 'primary', "Outline"),
    onClick: props.onSecondaryButtonClick,
    "data-testid": "confirmation-modal-secondary-btn"
  }, props.secondaryButtonLabel)) : /*#__PURE__*/React.createElement(Button, {
    fluid: true,
    onClick: onClose
  }, "Back")));
}